module.exports = __webpack_public_path__ + "static/media/Amarjit-Batra.1c745b60.png";